import * as React from 'react'

// A single label/value pair in the summary grid.
const SummaryItem = ({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) => (
  <div>
    <p className="mb-1 font-talent text-[16px] font-normal leading-[20px] text-[#656E83]">
      {label}
    </p>
    <p className="font-talent text-[16px] font-normal leading-[20px] text-[#1E2532]">
      {children}
    </p>
  </div>
)

type StepFourProps = {
  name: string
  checkinTypeLabel: string
  dateRangeLabel: string
  recurrenceLabel: string
  participantsLabel: string
  workflowLabel: string
}

export const StepFour = ({
  name,
  checkinTypeLabel,
  dateRangeLabel,
  recurrenceLabel,
  participantsLabel,
  workflowLabel,
}: StepFourProps) => (
  <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
    <SummaryItem label="Name">{name || '—'}</SummaryItem>
    <SummaryItem label="Type">{checkinTypeLabel}</SummaryItem>
    <SummaryItem label="Dates">{dateRangeLabel || '—'}</SummaryItem>
    <SummaryItem label="Recurrence">{recurrenceLabel}</SummaryItem>
    <SummaryItem label="Participants">{participantsLabel}</SummaryItem>
    <SummaryItem label="Workflow">{workflowLabel}</SummaryItem>
  </div>
)
